export default __webpack_public_path__ + "static/media/newsletter.a0a44dce.png";